export default __webpack_public_path__ + "static/media/multiclose.e6ce8795.svg";